import { combineReducers } from 'redux';

import organization from './organization';
import organizationDetails from './organization-details';
import organizationListings from './organization-listings';
import organizationDonate from './organization-donate';

export default combineReducers({
  organization,
  organizationDetails,
  organizationListings,
  organizationDonate
});
